import { cn } from "@/lib/utils";

export interface TestimonialAuthor {
  name: string;
  role: string;
  industry: string;
}

export interface TestimonialCardProps {
  author: TestimonialAuthor;
  text: string;
  className?: string;
}

export function TestimonialCard({ 
  author,
  text,
  className
}: TestimonialCardProps) {
  // Get first letter of name for avatar
  const initial = author.name.charAt(0).toUpperCase();
  
  return (
    <div
      className={cn(
        "flex flex-col gap-4 rounded-xl border bg-card p-5 shadow-card transition-all duration-300 hover:shadow-card-hover",
        "border-accent/20 hover:border-accent/40",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-accent/15 text-accent font-semibold text-lg">
          {initial}
        </div>
        <div className="flex flex-col">
          <span className="font-semibold text-foreground">
            {author.name}
          </span>
          <span className="text-sm text-muted-foreground">
            {author.role} • {author.industry}
          </span>
        </div>
      </div>
      <p className="text-foreground/80 leading-relaxed text-sm">
        "{text}"
      </p>
    </div>
  );
}